import { render } from "./NotFoundIndex.vue?vue&type=template&id=6e7f9f70&scoped=true"
const script = {}

import "./NotFoundIndex.vue?vue&type=style&index=0&id=6e7f9f70&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e7f9f70"]])

export default __exports__